module.exports = __webpack_public_path__ + "static/media/say_again.96bc5d9c.png";